import React, { forwardRef } from 'react'
import analytics from 'global/AnalyticsData'
import { getStepLabel } from 'components/NavBar/utils/getStepLabel'
import { DesktopNavBarButton } from './DesktopNavBarButton'
import removeLastStep from 'components/NavBar/utils/remove-last-step'
import './NavBar.scss'

const DesktopNavBar = forwardRef(function DesktopNavBar(
  {
    stepStatusArr,
    className,
    activeStepPosition,
    brk,
    onItemClicked,
    isHeaderVisible,
    style,
  },
  ref,
) {

  // console.log("stepstatusarr", stepStatusArr)
  const handleButtonClick = ({ stepStatus, index }) => {
    analytics.breakEvent('menu_navigation_click', brk, {
      context: activeStepPosition,
      result: index,
      context_total: stepStatusArr.length,
      context_position: activeStepPosition,
    })
    onItemClicked &&
      onItemClicked({
        stepId: stepStatus.id,
        position: index,
        isLocked: stepStatus.locked,
        isAlreadyTaken: stepStatus.complete,
      })
  }

  return (
    <div ref={ref} style={style} className={className}>
      {removeLastStep(stepStatusArr)?.map((stepStatus, index) => {
        const stepActive = stepStatus.position === parseInt(activeStepPosition)
        return (
          <DesktopNavBarButton
            key={index}
            onClick={() => handleButtonClick({ stepStatus, index })}
            className={`desktop-navbar-button ${stepActive ? 'active' : ''} ${
              isHeaderVisible ? '' : 'header-placement'
            }`}
            dangerouslySetInnerHTML={{
              __html: getStepLabel({
                label: stepStatus.label,
                stepType: stepStatus.type,
              }),
            }}
          />
        )
      })}
    </div>
  )
})

export { DesktopNavBar }
